'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var order = function order() {
  return import('@/page/order-infomation');
};
var orderBasic = function orderBasic() {
  return import('@/page/order-infomation/order-basic');
};
var orderDetail = function orderDetail() {
  return import('@/page/order-infomation/order-detail');
};
// const orderBack = () => import('@/page/order-infomation/order-back')
var payMethods = function payMethods() {
  return import('@/page/order-infomation/pay-methods');
};
var orderSuccess = function orderSuccess() {
  return import('@/page/order-infomation/pay-success');
};
var orderfail = function orderfail() {
  return import('@/page/order-infomation/pay-fail');
};
var payOffline = function payOffline() {
  return import('@/page/order-infomation/pay-offline');
};
var payPaid = function payPaid() {
  return import('@/page/order-infomation/pay-paid');
};
// const noticeList = () => import('@/page/order-infomation/notice-list')
exports.default = [{
  path: '/order',
  name: 'order',
  component: order,
  children: [{
    path: 'orderBasic',
    name: 'orderBasic',
    component: orderBasic
  }, {
    path: 'orderDetail',
    name: 'orderDetail',
    component: orderDetail
  },
  // {
  //   path: 'orderBack',
  //   name: 'orderBack',
  //   component: orderBack
  // },
  {
    path: 'payMethods',
    name: 'payMethods',
    component: payMethods
  }, {
    path: 'orderSuccess',
    name: 'orderSuccess',
    component: orderSuccess
  }, {
    path: 'orderfail',
    name: 'orderfail',
    component: orderfail
  }, {
    path: 'payOffline',
    name: 'payOffline',
    component: payOffline
  }, {
    path: 'payPaid',
    name: 'payPaid',
    component: payPaid
  }]
}];